import {CircularProgress} from "@mui/material";

const Loading = () => {
  return <div style={{height: "240px", display: "flex", alignItems:"center", justifyContent: "center", gap:"16px"}}>
      <CircularProgress sx={{color: "#FDBA2F"}}/>
      <span style={{fontWeight: 500, fontSize: "15px", lineHeight: "26px"}}>Загрузка</span>
  </div>
}

export default Loading